import { connect, ConnectedProps } from 'react-redux';
import { ErrorGuard } from '@noths/polaris-client-next-components';

import { ERROR_PRODUCT_NOT_FOUND } from 'src/constants/errors';
import { ReduxApplicationState } from 'src/redux/combinedReducer';

export const mapStateToProps = ({ product }: ReduxApplicationState) => ({
  error: product.error,
  notFoundErrorList: [ERROR_PRODUCT_NOT_FOUND],
});

const connector = connect(mapStateToProps);

export type ApiErrorGuardContainerProps = ConnectedProps<typeof connector>;

export const ApiErrorGuardContainer = connector(ErrorGuard);
